module.exports = __webpack_public_path__ + "static/media/Test59.cd4e9bb6.bmp";